import { createApi } from '@reduxjs/toolkit/query/react';
import { customBaseQuery } from 'services/baseQuery';

export const branchApi = createApi({
  baseQuery: customBaseQuery,
  reducerPath: 'branchApi',
  tagTypes: ['Branch'],
  endpoints: (builder) => ({
    getListBranches: builder.query({
      query: () => ({
        url: '/branches',
        method: 'GET',
      }),
    }),
    getBranchDetail: builder.query({
      query: (id) => ({
        url: `/branches/${id}`,
        method: 'GET'
      })
    }),
    createBranch: builder.mutation({
      query: ({ body }) => ({
        url: '/branches',
        method: 'POST',
        body: body
      })
    }),
    updateBranch: builder.mutation({
      query: ({ body, id}) => ({
        url: `/branches/${id}`,
        method: 'PATCH',
        body: body
      })
    }),
    deleteBranch: builder.mutation({
      query: ({ id }) => ({
        url: `/branches/${id}`,
        method: 'DELETE'
      })
    })
  }),
});

export const {
  useGetListBranchesQuery,
  useGetBranchDetailQuery,
  useUpdateBranchMutation,
  useCreateBranchMutation,
  useDeleteBranchMutation,
} = branchApi;
